import React from 'react'

import { Col, Row, TextFading } from '@yes.technology/react-toolkit'
import NavigationSliderTitle from '../NavigationSliderTitle/NavigationSliderTitle'
import {
  ActionsContainer,
  CollapsibleAreaLine,
  CollapsibleContainer,
  StyledGrid,
  TextFadingContainer
} from './styles'

type SectionDividerProps = {
  title?: string
  color?: string
  backgroundColor?: string
  children?: React.ReactNode
  centerHeaderElement?: React.ReactElement
  rightHeaderElement?: React.ReactElement
  embedded?: boolean
  disabled?: boolean
  isVisible?: boolean
  isCollapsibleCard?: boolean
  extendMobileAreaLine?: boolean
  hasTitleFading?: boolean
  hideCollapsibleCardArrow?: boolean
  navSticky?: boolean
} & React.HTMLAttributes<HTMLDivElement>

const SectionDivider = ({
  title = '',
  children,
  centerHeaderElement,
  rightHeaderElement,
  backgroundColor,
  color,
  embedded,
  isVisible = true,
  isCollapsibleCard = false,
  hasTitleFading = false,
  extendMobileAreaLine = false,
  hideCollapsibleCardArrow = false,
  navSticky,
  ...htmlProps
}: SectionDividerProps) => {
  const leftHeaderElement = hasTitleFading ? (
    <TextFadingContainer>
      <TextFading>
        <NavigationSliderTitle title={title} color={color} />
      </TextFading>
    </TextFadingContainer>
  ) : (
    <NavigationSliderTitle title={title} color={color} nowrap />
  )

  const actions = centerHeaderElement ? (
    <ActionsContainer>{centerHeaderElement}</ActionsContainer>
  ) : undefined

  if (!isVisible)
    return (
      <StyledGrid>
        <Row style={{ justifyContent: 'center' }}>
          <Col lg={12}>{children}</Col>
        </Row>
      </StyledGrid>
    )

  if (isCollapsibleCard) {
    return (
      <CollapsibleAreaLine
        heightClass='small'
        centerHeaderElement={actions}
        alignSecondPosition='right'
        headerColor='blue'
        defaultOpenState
        backgroundColor={backgroundColor}
        color={color}
        iconColor={color}
        navSticky={navSticky}
        displayToggleButton={!hideCollapsibleCardArrow}
        flexRightAreaElement
      >
        {children}
      </CollapsibleAreaLine>
    )
  }

  return (
    <CollapsibleContainer
      data-testid='section-divider'
      headerColor='blue'
      heightClass='small'
      leftHeaderElement={leftHeaderElement}
      centerHeaderElement={actions}
      rightHeaderElement={rightHeaderElement}
      alignSecondPosition='center'
      defaultOpenState
      backgroundColor={backgroundColor}
      color={color}
      extendSM={extendMobileAreaLine}
      iconColor={color}
      embedded={embedded}
      navSticky={navSticky}
      flexRightAreaElement
      displayToggleButton={!hideCollapsibleCardArrow}
      {...htmlProps}
    >
      {children}
    </CollapsibleContainer>
  )
}

export default SectionDivider
